import { render, staticRenderFns } from "./ReviewLetters.vue?vue&type=template&id=0df834ff&scoped=true&"
import script from "./ReviewLetters.vue?vue&type=script&lang=ts&"
export * from "./ReviewLetters.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewLetters.vue?vue&type=style&index=0&id=0df834ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df834ff",
  null
  
)

export default component.exports